import { nextTick } from 'vue';
import { useRoute } from 'vue-router';
import store from '@shared/store/index';
import DROPDOWN_NAMES from '@shared/constants/dropdowns/dropdownsName';

export function useNotificationPopupUrl() {
  const route = useRoute();

  //Генерация URL по модели и ID
  const getUrl = (obj) => {
    return (!obj.model_name)
      ? `/signal/${obj.post_id}?comment_id=${obj.object_id}`
      : `/${obj.model_name.toLowerCase()}/${obj.post_id}?comment_id=${obj.object_id}`;
  };

  //Обновить адрес без перезагрузки и запомнить предыдущий
  const toChangeUrl = (url) => {
    store.commit('ContentSystem/toRememberLastPageUrl', route.path);
    window.history.pushState({}, '', window.location.href);
    window.history.replaceState({}, '', url);
  };

  //Открытие попапа и смена адреса
  const toOpenContentPopup = async (notificationObj) => {
    store.dispatch('Dropdowns/removeTheDropdown', DROPDOWN_NAMES.contentPage);
    await nextTick();
    const url = getUrl(notificationObj);
    toChangeUrl(url);
    store.dispatch('Dropdowns/addNewDropdown', DROPDOWN_NAMES.contentPage);
  };

  return {
    toOpenContentPopup,
    getUrl,
    toChangeUrl,
  };
}